import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import TurnGrid from '../components/TurnGrid';

const TurnPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Turns</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <TurnGrid />
    </>
  );
};

export default TurnPage;
